var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { ApplicationContext } from '../context';
import { handleAction } from '../services/actions';
import { SpecificAction } from '../api';
import { renderDynamicComponent } from '../render';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';
var DynamicDialog = /** @class */ (function (_super) {
    __extends(DynamicDialog, _super);
    function DynamicDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicDialog.prototype.onClick = function (button) {
        if (button.action.contextSpecific) {
            if (button.action.contextSpecific == SpecificAction.Close) {
                return this.props.onCancel();
            }
        }
        handleAction(button.action, null, this.props.dataState, {
            context: this.context
        });
    };
    DynamicDialog.prototype.render = function () {
        // return <Modal
        // 	visible={true}
        // 	onCancel={this.props.onCancel.bind(this)}
        // 	footer={this.props.control.buttons
        // 		.map((button, index) => <Button key={index} onClick={() => this.onClick(button)}>{button.label}</Button>)}>
        // 	{renderDynamicComponent(1, this.props.control.content, this.props.dataState)}
        // </Modal>;
        // return <div>NULL</div>;
        var _this = this;
        return React.createElement(Dialog, { open: true, fullWidth: true, maxWidth: "md", onClose: this.props.onCancel.bind(this) },
            React.createElement(DialogTitle, null, this.props.control.title
                .map(function (child, index) { return renderDynamicComponent(index, child, _this.props.dataState); })),
            React.createElement(DialogContent, { dividers: true }, renderDynamicComponent(1, this.props.control.content, this.props.dataState)),
            React.createElement(DialogActions, null, this.props.control.buttons
                .map(function (button, index) { return React.createElement(Button, { key: index, onClick: function () { return _this.onClick(button); } }, button.label); })));
    };
    DynamicDialog.contextType = ApplicationContext;
    return DynamicDialog;
}(React.Component));
export default DynamicDialog;
//# sourceMappingURL=Dialog.js.map